<template>
  <a-page :image_source="image_source" :image_height="image_height">
    <a-hotel-selector-rms
      ref="a-hotel-selector-rms"
      v-if="isGroup"
    ></a-hotel-selector-rms>
    <pricing-strategy-app
      ref="pricing-strategy-app"
      v-else
    ></pricing-strategy-app>
  </a-page>
</template>

<script>
import aPage from "@/components/aPage";
import pricingStrategyApp from "@/components/app/pricingStrategyApp";
import aHotelSelectorRms from "@/components/selector/aHotelSelectorRms";
import { mapGetters } from "vuex";

export default {
  name: "pricing-strategy",
  components: {
    aPage,
    pricingStrategyApp,
    aHotelSelectorRms
  },
  data: () => ({
    image_source: "/img/header.jpg", //Mandatory path
    event_period: []
  }),
  computed: {
    isGroup() {
      return this.current_hotel && this.current_hotel.children_number > 0;
    },
    image_height() {
      return !this.isGroup ? 112 : 200;
    },
    ...mapGetters({
      current_hotel: "current_hotel"
    })
  },
  mounted() {
    if (this.$route.name === "pricing_strategy") {
      this.$router.push({
        name: "pricing_strategy_planning"
      });
    }
  }
};
</script>

<style scoped lang="scss">
#fullpage {
  ::v-deep .v-main__wrap {
    background-color: #f8f8f8 !important;
    min-height: 100vh;
  }
}
</style>
